import Select from 'react-select';
import {
  CustomOption,
  SelectWrapper,
  CustomSingleValue,
  CustomMultiValue,
  Label
} from './select.constants';

export const SimpleSelect = ({
  showCustomValue = true,
  wrapperStyles = {},
  label = 'Maximum Price',
  options,
  isDisabled,
  value,
  styles = {},
  onChange,
  isClearable = true,
  placeholder,
  ...props
}) => {
  const { control: controlStyles = {}, ...customStyles } = styles;
  return (
    <SelectWrapper style={{ ...wrapperStyles, zIndex: wrapperStyles.zIndex || 9 }}>
      <Label>{label}</Label>

      <Select
        isDisabled={isDisabled}
        options={options}
        styles={{
          control: (provided, state) => ({
            ...provided,
            borderRadius: '8px',
            border: '1px solid #EDEBED',
            background: '#FFF',
            ...controlStyles
          }),
          ...customStyles
        }}
        components={{
          Option: CustomOption,
          ...(showCustomValue && {
            SingleValue: CustomSingleValue,
            MultiValue: CustomMultiValue
          })
        }}
        isClearable={isClearable}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
    </SelectWrapper>
  );
};
